//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "RemoveRole",
  data() {
    return {};
  },
  props: {
    dialogRemoveRoleVisible: {
      type: Boolean,
      default: () => true,
    },
    curAccountDetail: {
      type: Object,
      default: () => {},
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    operation: {
      type: Number,
      default: () => 1,
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-05-24 09:39:38
     * @return {*}
     */
    close(type) {
      this.$emit("close", "dialogRemoveRoleVisible", type);
    },
    /**
     * @descripttion: 取消移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:36:36
     */
    handleCancelRemoveRole() {
      this.close(
        this.operation == 1
          ? "dialogMemberVisible"
          : "dialogConfigRoleAuthVisible"
      );
    },
    /**
     * @descripttion: 取消移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:36:36
     */
    handleSureRemoveRole() {
      if (this.operation == 1) {
        this.delRefAccountRole();
      } else {
        this.delRole();
      }
    },
    /**
     * @description: 移除角色
     * @Author: yangsibo
     * @Date: 2022-05-25 15:19:25
     * @return {*}
     */
    async delRefAccountRole() {
      let params = {
        accountId: this.curAccountDetail.id,
        roleId: this.curRoleDetail.id,
      };
      try {
        let { status } = await this.$http.role.delRefAccountRole({
          ...params,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "移除角色成功",
            duration: 2000,
          });
          this.close();
          this.$emit("getRoleList");
        }
      } catch (error) {}
    },
    /**
     * @description: 删除角色
     * @Author: yangsibo
     * @Date: 2022-05-25 15:18:50
     * @return {*}
     */
    async delRole() {
      try {
        let { status } = await this.$http.role.delRole({
          id: this.curRoleDetail.id,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "删除角色成功",
            duration: 2000,
          });
          this.close();
          this.$emit("getRoleList");
        }
      } catch (error) {}
    },
  },
  created() {},
  mounted() {},
};
